// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Format = require("bs-platform/lib/js/format.js");
var Random = require("bs-platform/lib/js/random.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");
var Caml_js_exceptions = require("bs-platform/lib/js/caml_js_exceptions.js");

function map(f, param) {
  if (param !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(param)));
  }
  
}

function map_or($$default, f, param) {
  if (param !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(param));
  } else {
    return $$default;
  }
}

function map_lazy(default_fn, f, param) {
  if (param !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(param));
  } else {
    return Curry._1(default_fn, /* () */0);
  }
}

function is_some(param) {
  return param !== undefined;
}

function is_none(param) {
  return param === undefined;
}

function compare(f, o1, o2) {
  if (o1 !== undefined) {
    if (o2 !== undefined) {
      return Curry._2(f, Caml_option.valFromOption(o1), Caml_option.valFromOption(o2));
    } else {
      return 1;
    }
  } else if (o2 !== undefined) {
    return -1;
  } else {
    return 0;
  }
}

function equal(f, o1, o2) {
  if (o1 !== undefined) {
    if (o2 !== undefined) {
      return Curry._2(f, Caml_option.valFromOption(o1), Caml_option.valFromOption(o2));
    } else {
      return false;
    }
  } else {
    return o2 === undefined;
  }
}

function $$return(x) {
  return Caml_option.some(x);
}

function $great$pipe$eq(x, f) {
  return map(f, x);
}

function $great$great$eq(o, f) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  }
  
}

function flat_map(f, o) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  }
  
}

function pure(x) {
  return Caml_option.some(x);
}

function $less$star$great(f, x) {
  if (f !== undefined && x !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(x)));
  }
  
}

function or_(else_, a) {
  if (a !== undefined) {
    return a;
  } else {
    return else_;
  }
}

function or_lazy(else_, a) {
  if (a !== undefined) {
    return a;
  } else {
    return Curry._1(else_, /* () */0);
  }
}

function $less$plus$great(a, b) {
  return or_(b, a);
}

function choice(l) {
  return List.fold_left($less$plus$great, undefined, l);
}

function map2(f, o1, o2) {
  if (o1 !== undefined && o2 !== undefined) {
    return Caml_option.some(Curry._2(f, Caml_option.valFromOption(o1), Caml_option.valFromOption(o2)));
  }
  
}

function filter(p, o) {
  if (o !== undefined && Curry._1(p, Caml_option.valFromOption(o))) {
    return o;
  }
  
}

function if_(p, x) {
  if (Curry._1(p, x)) {
    return Caml_option.some(x);
  }
  
}

function exists(p, param) {
  if (param !== undefined) {
    return Curry._1(p, Caml_option.valFromOption(param));
  } else {
    return false;
  }
}

function for_all(p, param) {
  if (param !== undefined) {
    return Curry._1(p, Caml_option.valFromOption(param));
  } else {
    return true;
  }
}

function iter(f, o) {
  if (o !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(o));
  } else {
    return /* () */0;
  }
}

function fold(f, acc, o) {
  if (o !== undefined) {
    return Curry._2(f, acc, Caml_option.valFromOption(o));
  } else {
    return acc;
  }
}

function get_or($$default, x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  } else {
    return $$default;
  }
}

function get_exn(param) {
  if (param !== undefined) {
    return Caml_option.valFromOption(param);
  } else {
    return Pervasives.invalid_arg("CCOpt.get_exn");
  }
}

function get_lazy(default_fn, x) {
  if (x !== undefined) {
    return Caml_option.valFromOption(x);
  } else {
    return Curry._1(default_fn, /* () */0);
  }
}

function sequence_l(l) {
  try {
    var _acc = /* [] */0;
    var _l = l;
    while(true) {
      var l$1 = _l;
      var acc = _acc;
      if (l$1) {
        var match = l$1[0];
        if (match !== undefined) {
          _l = l$1[1];
          _acc = /* :: */[
            Caml_option.valFromOption(match),
            acc
          ];
          continue ;
        } else {
          throw Pervasives.Exit;
        }
      } else {
        return List.rev(acc);
      }
    };
  }
  catch (exn){
    if (exn === Pervasives.Exit) {
      return ;
    } else {
      throw exn;
    }
  }
}

function wrap($staropt$star, f, x) {
  var handler = $staropt$star !== undefined ? $staropt$star : (function (param) {
        return true;
      });
  try {
    return Caml_option.some(Curry._1(f, x));
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    if (Curry._1(handler, e)) {
      return ;
    } else {
      throw e;
    }
  }
}

function wrap2($staropt$star, f, x, y) {
  var handler = $staropt$star !== undefined ? $staropt$star : (function (param) {
        return true;
      });
  try {
    return Caml_option.some(Curry._2(f, x, y));
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    if (Curry._1(handler, e)) {
      return ;
    } else {
      throw e;
    }
  }
}

function to_list(o) {
  if (o !== undefined) {
    return /* :: */[
            Caml_option.valFromOption(o),
            /* [] */0
          ];
  } else {
    return /* [] */0;
  }
}

function of_list(param) {
  if (param) {
    return Caml_option.some(param[0]);
  }
  
}

function to_result(err, param) {
  if (param !== undefined) {
    return /* Ok */Block.__(0, [Caml_option.valFromOption(param)]);
  } else {
    return /* Error */Block.__(1, [err]);
  }
}

function to_result_lazy(err_fn, param) {
  if (param !== undefined) {
    return /* Ok */Block.__(0, [Caml_option.valFromOption(param)]);
  } else {
    return /* Error */Block.__(1, [Curry._1(err_fn, /* () */0)]);
  }
}

function of_result(param) {
  if (param.tag) {
    return ;
  } else {
    return Caml_option.some(param[0]);
  }
}

var Infix = {
  $great$pipe$eq: $great$pipe$eq,
  $great$great$eq: $great$great$eq,
  $less$star$great: $less$star$great,
  $less$$great: map,
  $less$plus$great: $less$plus$great
};

function random(g, st) {
  if (Random.State.bool(st)) {
    return Caml_option.some(Curry._1(g, st));
  }
  
}

var ExitChoice = Caml_exceptions.create("CCOpt.ExitChoice");

function choice_seq(s) {
  var r = {
    contents: undefined
  };
  try {
    Curry._1(s, (function (o) {
            if (o !== undefined) {
              r.contents = o;
              throw ExitChoice;
            } else {
              return /* () */0;
            }
          }));
  }
  catch (exn){
    if (exn !== ExitChoice) {
      throw exn;
    }
    
  }
  return r.contents;
}

function to_gen(o) {
  if (o !== undefined) {
    var first = {
      contents: true
    };
    return (function (param) {
        if (first.contents) {
          first.contents = false;
          return o;
        }
        
      });
  } else {
    return (function (param) {
        return ;
      });
  }
}

function to_seq(o, k) {
  if (o !== undefined) {
    return Curry._1(k, Caml_option.valFromOption(o));
  } else {
    return /* () */0;
  }
}

function pp(ppx, out, param) {
  if (param !== undefined) {
    return Curry._2(Format.fprintf(out, /* Format */[
                    /* Formatting_gen */Block.__(18, [
                        /* Open_box */Block.__(1, [/* Format */[
                              /* End_of_format */0,
                              ""
                            ]]),
                        /* String_literal */Block.__(11, [
                            "Some ",
                            /* Alpha */Block.__(15, [/* Formatting_lit */Block.__(17, [
                                    /* Close_box */0,
                                    /* End_of_format */0
                                  ])])
                          ])
                      ]),
                    "@[Some %a@]"
                  ]), ppx, Caml_option.valFromOption(param));
  } else {
    return Format.pp_print_string(out, "None");
  }
}

function flatten(param) {
  if (param !== undefined) {
    return Caml_option.valFromOption(param);
  }
  
}

function return_if(b, x) {
  if (b) {
    return Caml_option.some(x);
  }
  
}

var $less$$great = map;

exports.map = map;
exports.map_or = map_or;
exports.map_lazy = map_lazy;
exports.is_some = is_some;
exports.is_none = is_none;
exports.compare = compare;
exports.equal = equal;
exports.$$return = $$return;
exports.$great$pipe$eq = $great$pipe$eq;
exports.$great$great$eq = $great$great$eq;
exports.flat_map = flat_map;
exports.map2 = map2;
exports.iter = iter;
exports.fold = fold;
exports.filter = filter;
exports.if_ = if_;
exports.exists = exists;
exports.for_all = for_all;
exports.get_or = get_or;
exports.get_exn = get_exn;
exports.get_lazy = get_lazy;
exports.sequence_l = sequence_l;
exports.wrap = wrap;
exports.wrap2 = wrap2;
exports.pure = pure;
exports.$less$star$great = $less$star$great;
exports.$less$$great = $less$$great;
exports.or_ = or_;
exports.or_lazy = or_lazy;
exports.$less$plus$great = $less$plus$great;
exports.choice = choice;
exports.flatten = flatten;
exports.return_if = return_if;
exports.Infix = Infix;
exports.to_list = to_list;
exports.of_list = of_list;
exports.to_result = to_result;
exports.to_result_lazy = to_result_lazy;
exports.of_result = of_result;
exports.random = random;
exports.choice_seq = choice_seq;
exports.to_gen = to_gen;
exports.to_seq = to_seq;
exports.pp = pp;
/* Format Not a pure module */
